import store  from '@/store';

export const MESSAGE_TYPES = {
    ERROR:'error',
    INFO:'info',
    WARNING:'warning',
    SUCCESS:'success'
}
const notifyMutation = 'notify';

const createMessage = (message,type)=>{
    return {message,type}
}

export const notify = (message,type=MESSAGE_TYPES.SUCCESS) => store.commit(notifyMutation,createMessage(message,type),{root:true});
export const notifyWarn = (message)=> notify(message,MESSAGE_TYPES.WARNING);
export const notifyInfo =(message) =>notify(message,MESSAGE_TYPES.INFO);
export const notifyError = (message)=>notify (message,MESSAGE_TYPES.ERROR);
export const notifyApiError = ({message}) => notifyError(message);
  

